module.exports = __webpack_public_path__ + "img/shequ_on.04ecf320.png";